import React from "react";
import { NotificationsView } from "@/components/NotificationsView";
export default function ManagerNotifications() { return <NotificationsView />; }
